import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map, filter, take } from 'rxjs/operators';
import { WindowService } from '@nx-customer-apps/shared/services';
import { RoutePaths, Status } from '@nx-customer-apps/shared/enums';
import { StatusPageService } from '../../../../services';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'vp-unavailable',
    templateUrl: './unavailable.component.html',
    styleUrls: ['../errors.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, TranslatePipe]
})
export class UnavailableComponent implements OnInit {
    private statusPageService = inject(StatusPageService);
    private windowService = inject(WindowService);
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);

    public activeStatus: Status = Status.UnderMaintenance;
    public readonly status = Status;

    public ngOnInit(): void {
        this.handleRouteStatus();
        this.handleStatusChange();
    }

    public reload(): void {
        this.windowService.reloadOrigin();
    }

    private handleRouteStatus(): void {
        const status = this.activatedRoute.snapshot.queryParamMap.get('status');
        if (status && [Status.MajorOutage, Status.UnderMaintenance].includes(status as Status)) {
            this.activeStatus = status as Status;
        }
    }

    private handleStatusChange(): void {
        this.statusPageService.state$
            .pipe(
                map(() => this.statusPageService.isUnavailable()),
                // Filter to only proceed if the service is available
                filter(isUnavailable => !isUnavailable),
                take(1)
            )
            .subscribe(() => {
                this.router.navigate([RoutePaths.Projects]);
            });
    }
}
